import { flatten } from 'utils/flat';

export const getReactQueryKeys = (params) => {
  const flattenObj = flatten(params);

  return Object.keys(flattenObj)
    .sort()
    .map((key) => `${key}=${JSON.stringify(flattenObj[key])}`);
};
